import { NgModule } from '@angular/core';

import { PartyIdentificationCodeTypePipe } from './party-identification-code-type.pipe';
import { PartyIdentificationDocumentPipe } from './party-identification-document.pipe';

@NgModule({
  declarations: [PartyIdentificationCodeTypePipe, PartyIdentificationDocumentPipe],
  exports: [PartyIdentificationCodeTypePipe, PartyIdentificationDocumentPipe]
})
export class PartyIdentificationModule {}
